export default "__VITE_ASSET__BFKoqR4G__"